export default [
  {
    startDate: new Date().toISOString().substr(0, 10),
    protocol: '12345656',
    channel: 'Webclient',
    document: '000.000.000-00',
    user: 'Pessoa 1',
    group: 'Fila 1',
    operator: 'Operator 1'
  },
  {
    startDate: new Date().toISOString().substr(0, 10),
    protocol: '12345656',
    channel: 'Webclient',
    document: '000.000.000-00',
    user: 'Pessoa 2',
    group: 'Fila 2',
    operator: 'Operator 2'
  },
  {
    startDate: new Date().toISOString().substr(0, 10),
    protocol: '12345656',
    channel: 'Webclient',
    document: '000.000.000-00',
    user: 'Pessoa 3',
    group: 'Fila 3',
    operator: 'Operator 3'
  }
]
